import { css } from 'styled-components'

export const scrollableNodeStyles = css`
  height: calc(100% + 1px);
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
`
